import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Global } from '../api/Global';
import { API } from '../api/API';
import ConfirmBox from '../ui/ConfirmBox';
import { Tooltip } from 'reactstrap';
import CustomModal from '../ui/CustomModal';
import Loader from '../ui/Loader';

class PostHeader extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      confirmBoxMsg: null,
      id: null,
      img: null,
      title: null,
      updatedAt: null,
      from: null,
      creatorName: null,
      showConfirmBox: false,
      isCommentable: false,
      isPinned: false,
      isSchedule: false,
      pinnedBy: null,
      isDrafted: false,
      socialMedia: null,
      publishedPosts: [],
      tooltipOpen: false,
      // push notification status
      confirmPushNotification: false,
      showPushNotificationModal: false,
      pushnotificationTitle: '',
      pushnotificationBody: '',
      responseMsg: '',
      currentPostId: null,
      pushnotificationTitleError : '',
      pushnotificationBodyError : '',
      loading : false,
    };

    // Bind methods
    this.showConfirmBox = this.showConfirmBox.bind(this);
    this.donotRemovePost = this.donotRemovePost.bind(this);
    this.selectedCommentStatus = this.selectedCommentStatus.bind(this);
    this.cancelRemovePost = this.cancelRemovePost.bind(this);
    this.pinPostHandler = this.pinPostHandler.bind(this);
    this.removePost = this.removePost.bind(this);
    this.publishPost = this.publishPost.bind(this);
    this.toggle = this.toggle.bind(this);
    this.isAuthorizeUser = this.isAuthorizeUser.bind(this);
    this.handlePushNotificationChange = this.handlePushNotificationChange.bind(this);
    this.handleSubmitPushNotification = this.handleSubmitPushNotification.bind(this);
    this.handleShowPushNotificationModal = this.handleShowPushNotificationModal.bind(this);
    this.handleClosePushNotificationModal = this.handleClosePushNotificationModal.bind(this);

    
  }

  showConfirmBox(val) {
    try {
      this.setState({
        showConfirmBox: true,
        confirmBoxMsg: val,
      });
    } catch (error) {
      console.log(error);
    }
  }

  componentDidMount() {
    try {
      this.setState({
        id: this.props.id || null,
        img: this.props.img || null,
        title: this.props.title || null,
        updatedAt: this.props.updatedAt || null,
        from: this.props.from || null,
        creatorName: this.props.creatorName || null,
        isPinned: this.props.isPinned || false,
        isSchedule: this.props.isSchedule || false,
        showConfirmBox: this.props.showConfirmBox || false,
        isCommentable: this.props.isCommentable || false,
        pinnedBy: this.props.pinnedBy || null,
        isDrafted: this.props.isDrafted || false,
        socialMedia: this.props.socialMedia || null,
      });
    } catch (error) {
      console.log(error);
    }
  }

  donotRemovePost() {
    try {
      this.setState({
        showConfirmBox: false,
      });
    } catch (error) {
      console.log(error);
    }
  }

  selectedCommentStatus(val) {
    try {
      const obj = {
        id: this.props.id,
        status: val,
      };

      API.setPostCommentStatus(obj)
        .then((response) => {
          if (response && response.data && response.data.data) {
            if (val === true) {
              this.props.onAlert('Commenting for user is activated');
              this.setState({
                isCommentable: true,
              });
            } else {
              this.props.onAlert('Commenting for user is deactivated');
              this.setState({
                isCommentable: false,
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  }

  isAuthorizeUser() {
    try {
      let status = true;
      const user = Global.user();

      if (user === 'learner') {
        status = false;
      }

      return status;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  cancelRemovePost() {
    this.setState({
      showConfirmBox: false,
    });
  }

  async pinPostHandler() {
    try {
      const result = await API.pinTogglePost({
        id: this.state.id,
        status: this.state.isPinned,
      });
      if (result) {
        this.props.onCrawlPostList();
      }
    } catch (error) {
      console.error('Error pinning post:', error);
    }
  }

  removePost() {
    this.setState(
      {
        showConfirmBox: false,
      },
      () => {
        this.props.onRemovePost(this.state.id);
      },
    );
  }

  async publishPost(id) {
    try {
      const response = await API.publishPost(id);
      console.log('Publish response:', response);
      if(response.status){
        this.setState({
          responseMsg: response.message,
          confirmPushNotification: true,
          showPushNotificationModal: true,
          currentPostId: id,
        });
      } else {
        this.props.onAlert(response.message);
      }
      
      this.setState((prevState) => ({
        publishedPosts: [...prevState.publishedPosts, id],
      }));
    } catch (error) {
      console.log(error);
    }
  }

  handleShowPushNotificationModal() {
    this.setState({
      confirmPushNotification: false, // This hides the first modal
      showPushNotificationModal: true, // Keep this true for the form modal
    });
  }
  
  handleClosePushNotificationModal() {
    this.setState({
      confirmPushNotification: false,
      showPushNotificationModal: false,
      pushnotificationTitle: '',
      pushnotificationBody: '',
      responseMsg: '',
      currentPostId: null,
    });
  }

  handlePushNotificationChange(e) {
    const { name, value } = e.target;
    if(name === 'pushnotificationTitle'){
      this.setState({
        pushnotificationTitleError: '',
      });
    } else if(name === 'pushnotificationBody'){
      this.setState({
        pushnotificationBodyError: '',
      });
    }
    this.setState({
      [name]: value
    });
  }

  handleSubmitPushNotification() {
    const { pushnotificationTitle, pushnotificationBody, currentPostId  } = this.state;
    this.setState({ loading: true });
    
    if(pushnotificationTitle.trim() === '' || pushnotificationBody.trim() === ''){
      this.setState({
        pushnotificationTitleError: 'Please fill in both title and body for the push notification.',
      });
      return;
    } else if(pushnotificationTitle.length > 50 || pushnotificationTitle.length < 5){
      this.setState({
        pushnotificationTitleError: 'Push notification title should be between 5 and 50 characters.',
      });
      return;
    } else if(pushnotificationBody.length > 200 || pushnotificationBody.length < 5){
      this.setState({
        pushnotificationBodyError: 'Push notification body should be between 5 and 200 characters.',
      });
      return;
    }
    // Send push notification
    const notificationData = {
      postId: this.state.currentPostId,
      title: pushnotificationTitle,
      body: pushnotificationBody,
    };

     API.sendPushNotificationFromSocialMediaPost(notificationData)
    .then(response => {
      if (response && response.status === 200) {
        this.props.onAlert('Push notification sent successfully');
        this.setState({ loading: false });
        // Update the post list with the response data
        if (this.props.onUpdatePushNotification && response.data) {
          this.props.onUpdatePushNotification({
            _id: response.data._id,
            newsFeedClientId: response.data.postId ||  this.state.currentPostId,
            push_notification_status: response.data.push_notification_status || true,
            push_notification_title: response.data.push_notification_title || pushnotificationTitle,
            push_notification_message: response.data.push_notification_message || pushnotificationBody,
            only_for_free_users: response.data.only_for_free_users || true
          });
          // this.setState({
          //   isDrafted: false,
          // });
        }
        
        // Close modal only after successful API call
        this.handleClosePushNotificationModal();
      } else {
        this.props.onAlert(response?.message || 'Failed to send push notification');
      }
    })
    .catch(error => {
        this.setState({ loading: false });
        this.props.onAlert(error?.response?.data?.message || 'Failed to send push notification');
    });
  }
  toggle() {
    this.setState((prevState) => ({
      tooltipOpen: !prevState.tooltipOpen,
    }));
  }

  render() {
    const {
      id,
      img,
      title,
      updatedAt,
      from,
      creatorName,
      showConfirmBox,
      isCommentable,
      isPinned,
      pinnedBy,
      isDrafted,
      tooltipOpen,
      socialMedia,
    } = this.state;

    console.log({ socialMedia });

    const instagramIcon = (
      <>
        <svg
          width="24"
          height="24"
          fill="#000000"
          viewBox="0 0 256 256"
          xmlns="http://www.w3.org/2000/svg"
          id="instaPost"
        >
          <g strokeWidth="0"></g>
          <g strokeLinecap="round" strokeLinejoin="round"></g>
          <g>
            <path d="M128,84a44,44,0,1,0,44,44A44.04978,44.04978,0,0,0,128,84Zm0,80a36,36,0,1,1,36-36A36.04061,36.04061,0,0,1,128,164ZM172,32H84A52.059,52.059,0,0,0,32,84v88a52.059,52.059,0,0,0,52,52h88a52.059,52.059,0,0,0,52-52V84A52.059,52.059,0,0,0,172,32Zm44,140a44.04978,44.04978,0,0,1-44,44H84a44.04978,44.04978,0,0,1-44-44V84A44.04978,44.04978,0,0,1,84,40h88a44.04978,44.04978,0,0,1,44,44ZM188,76a8,8,0,1,1-8-8A8.00917,8.00917,0,0,1,188,76Z"></path>
          </g>
        </svg>
        <Tooltip target="instaPost" isOpen={tooltipOpen} toggle={this.toggle}>
          This is a post drafted from Instagram. Click on publish on the
          dropdown menu to publish it.
        </Tooltip>
      </>
    );

    const xIcon = (
      <>
        <svg
          width="28"
          height="28"
          viewBox="0 0 256 256"
          fill="black"
          xmlns="http://www.w3.org/2000/svg"
          id="xIconDraft"
        >
          <g transform="scale(0.2) translate(0, 20)">
            <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
          </g>
        </svg>
        <Tooltip target="xIconDraft" isOpen={tooltipOpen} toggle={this.toggle}>
          This is a post drafted from X. Click on publish on the dropdown menu
          to publish it.
        </Tooltip>
      </>
    );

    return (
      <>
        {showConfirmBox && (
          <ConfirmBox
            onCancel={this.cancelRemovePost}
            onOK={this.removePost}
            msg={this.state.confirmBoxMsg}
          />
        )}

        {/* First Modal - Confirmation */}
        {
          this.state.loading && (
            <Loader />
          )
        }
        {this.state.confirmPushNotification && this.state.showPushNotificationModal && (
          <CustomModal
            isOpen={this.state.showPushNotificationModal}
            onClose={this.handleClosePushNotificationModal}
            title="Push Notification"
            showConfirmButton={false}
            showCancelButton={false}
             closeOnBackdropClick={false}
             modalSize="sm"
             showCloseButton={true}
          >
            <p className="textCenter">{this.state.responseMsg}</p>
            <p className="textCenter">Do you want to send Push notifications for this post?</p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
              <button className="btn btn-secondary" onClick={this.handleClosePushNotificationModal}>No</button>
              <button className="btn btn-primary" onClick={this.handleShowPushNotificationModal}>Yes</button>
            </div>
          </CustomModal>
        )}

        {/* Second Modal - Form */}
        {!this.state.confirmPushNotification && this.state.showPushNotificationModal && (
          <CustomModal
            isOpen={this.state.showPushNotificationModal}
            onClose={this.handleClosePushNotificationModal}
            title="Send Push Notification"
            showConfirmButton={false}
            showCancelButton={false}
             closeOnBackdropClick={false}
             modalSize="sm"
             showCloseButton={true}
          >
            <div className="form-group">
              <label htmlFor="pushnotificationTitle">Push notification title</label>
              <input
                type="text"
                className="form-control"
                id="pushnotificationTitle"
                name="pushnotificationTitle"
                value={this.state.pushnotificationTitle}
                onChange={this.handlePushNotificationChange}
                // placeholder="Enter push notification title"
                maxLength="50"
              />
            
              {
                this.state.pushnotificationTitleError && (
                  <div className="text-danger">
                     <small>{this.state.pushnotificationTitleError}</small> 
                  </div>
                )
              }
            </div>

            <div className="form-group">
              <label htmlFor="pushnotificationBody">Push notification message</label>
              <textarea
                className="form-control"
                id="pushnotificationBody"
                name="pushnotificationBody"
                value={this.state.pushnotificationBody}
                onChange={this.handlePushNotificationChange}
                // placeholder="Enter push notification message"
                rows="4"
                maxLength="200"
              />
           
              {
                this.state.pushnotificationBodyError && (
                  <div className="text-danger">
                     <small>{this.state.pushnotificationBodyError}</small> 
                  </div>
                )
              }

            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button className="btn btn-secondary" onClick={this.handleClosePushNotificationModal}>Cancel</button>
                 <button className="btn btn-primary" onClick={this.handleSubmitPushNotification} style={{ backgroundColor: "var(--blue-color)" }}>Send</button>
              
            </div>
          </CustomModal>
        )}

        <header>
          <div className="leftSide">
            <img
              className="tinyimg"
              src={img || '/img/logo.png'}
              alt={creatorName || ''}
            />
            <div className="shortUserInfo">
              <h3>{title}</h3>
              <div className="timeago">
                {updatedAt} . {from}
              </div>
            </div>
          </div>
          <div className="rightSide">
            {isDrafted &&
              Global.user() === 'admin' &&
              (socialMedia === 'Instagram' ? (
                <span style={{ fontSize: '0.8em', color: 'gray' }}>
                  {instagramIcon} <i>Imported from Instagram</i>
                </span>
              ) : (
                <span style={{ fontSize: '0.8em', color: 'gray' }}>
                  {xIcon} <i>Imported from X</i>
                </span>
              ))}
            {Global.user() === 'admin' && (
              <button className="link">
                <img
                  src="/img/edit.svg"
                  alt="Edit"
                  title="Edit"
                  onClick={() => this.props.onShowEditPost(id)}
                />
              </button>
            )}

            {this.isAuthorizeUser() && (
              <div className="link options">
                <img src="/img/options.svg" alt="Options" title="Options" />
                <div className="optionsPop">
                  <h4>Post Options</h4>
                  <div className="item">
                    <button
                      className={isCommentable === true ? 'active' : ''}
                      onClick={() => this.selectedCommentStatus(true)}
                    >
                      <span></span>
                      Comment On
                    </button>
                  </div>
                  <div className="item">
                    <button
                      onClick={() => this.selectedCommentStatus(false)}
                      className={isCommentable === false ? 'active' : ''}
                    >
                      <span></span>
                      Comment Off
                    </button>
                  </div>

                  {Global.user() === 'admin' && isPinned === false && (
                    <div className="item">
                      <button
                        className="linkonly"
                        onClick={() =>
                          this.showConfirmBox(
                            'Are you sure you want to remove post ?',
                          )
                        }
                      >
                        Remove Post
                      </button>
                    </div>
                  )}

                  {Global.user() === 'admin' &&
                    pinnedBy !== 'system' &&
                    !isDrafted &&
                    this.state.isSchedule === false && (
                      <div className="item">
                        <button
                          className="linkonly"
                          onClick={this.pinPostHandler}
                        >
                          {isPinned ? 'Unpin Post' : 'Pin Post'}
                        </button>
                      </div>
                    )}

                  {Global.user() === 'admin' && isDrafted === true &&
                    !this.state.publishedPosts.includes(id) && (
                      <div className="item">
                        <button
                          className="linkonly"
                          onClick={() => this.publishPost(id)}
                        >
                          Publish Post
                        </button>
                      </div>
                    )}
                </div>
              </div>
            )}
          </div>
        </header>
      </>
    );
  }
}

PostHeader.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  img: PropTypes.string,
  title: PropTypes.string,
  updatedAt: PropTypes.string,
  from: PropTypes.string,
  creatorName: PropTypes.string,
  showConfirmBox: PropTypes.bool,
  isCommentable: PropTypes.bool,
  isPinned: PropTypes.bool,
  isSchedule: PropTypes.bool,
  pinnedBy: PropTypes.string,
  isDrafted: PropTypes.bool,
  onAlert: PropTypes.func,
  onShowEditPost: PropTypes.func,
  onCrawlPostList: PropTypes.func,
  onRemovePost: PropTypes.func,
 onUpdatePushNotification: PropTypes.func,
};

export default React.memo(PostHeader);